import { useLanguage } from '../context/LanguageContext';
import {
  useProducts, useTestimonials,
  useGalleryPhotos, useGalleryVideos,
} from './useCMS';

const pick = (dict, lang) => (dict?.[lang] || dict?.en || '');
const pickArr = (dict, lang) => (dict?.[lang] || dict?.en || []);

// Returns products in the flat legacy shape so consumer components don't change.
export function useLocalizedProducts() {
  const { lang } = useLanguage();
  const { items, loading, refresh } = useProducts();
  const list = (items || []).map((p) => ({
    id: p.slug || p.id,       // used for scroll anchor + icon/gallery lookups
    _id: p.id,                // real Mongo id
    slug: p.slug,
    name: pick(p.name, lang),
    tagline: pick(p.tagline, lang),
    description: pick(p.description, lang),
    specs: pickArr(p.specs, lang),
    color: p.color || 'from-forest-900 to-forest-500',
    image: p.image_url,
  }));
  return { products: list, loading, refresh };
}

export function useLocalizedTestimonials() {
  const { lang } = useLanguage();
  const { items, loading } = useTestimonials();
  const list = (items || []).map((t) => ({
    id: t.id,
    name: pick(t.name, lang),
    location: pick(t.location, lang),
    role: pick(t.role, lang),
    quote: pick(t.quote, lang),
  }));
  return { testimonials: list, loading };
}

export function useLocalizedGalleryPhotos() {
  const { items, loading } = useGalleryPhotos();
  return { photos: items || [], loading };
}

export function useLocalizedGalleryVideos() {
  const { items, loading } = useGalleryVideos();
  return { videos: items || [], loading };
}
